//
//
//
//
//
//
//
//
//
//
//
//
//
import newUserPaid from "./newRoleOccupationPaymentRate/newUserPaid";
import levelPaymentAmount from "./newRoleOccupationPaymentRate/levelPaymentAmount";
import levelPaymentFrequency from "./newRoleOccupationPaymentRate/levelPaymentFrequency";
export default {
  name: "newRoleOccupationPaymentRate",
  components: {
    newUserPaid: newUserPaid,
    levelPaymentAmount: levelPaymentAmount,
    levelPaymentFrequency: levelPaymentFrequency
  },
  mixins: [],
  data: function data() {
    return {
      activeIndex: 'newUserPaid'
    };
  },
  created: function created() {},
  activated: function activated() {},
  methods: {
    handover: function handover(index) {
      this.activeIndex = index;
    }
  }
};